<template>
  <div class="permissions">
    <div class="title row column-s">
      <div class="grid-8-m grid-9-g grid-12-s text-center-s">
        <i class="fa fa-lock" />&nbsp; PERMISSÕES
      </div>
    </div>
    <div class="row-g column-m column-s">
      <div class="menus grid-6-g">
        <div class="title row align-center">
          <i class="fa fa-list" /> Menus

          <Button :layout="showNewMenu ? 'red-go' : 'green-go'" title="NOVO MENU" @click="showNewMenu = !showNewMenu">{{
            showNewMenu ? "x" : "+" }}</Button>
        </div>
        <form v-if="showNewMenu" class="form" onsubmit="return false" @submit="newMenu">
          <div class="title">Novo Menu</div>
          <div class="row justify-around column-s">
            <div class="column grid-3 grid-12-s">
              <label>Nome</label>
              <input class="input" placeholder="Nome" v-model="menuForm.nome" required />
            </div>
            <div class="column grid-3 grid-12-s">
              <label>Id</label>
              <input class="input" placeholder="Id" v-model="menuForm.id_menu" required />
            </div>
            <div class="column grid-3 grid-12-s">
              <label>URL</label>
              <input class="input" placeholder="URL" v-model="menuForm.url" required />
            </div>
          </div>
          <div class="controls text-right">
            <Button layout="green-go" type="submit" :loader="loader.menu.new">ADICIONAR</Button>
          </div>
        </form>

        <div class="list">
          <div v-if="loader.menu.list" class="column align-center justify-center">
            <Loader layout="small" />
          </div>
          <template v-else>
            <div class="head row">
              <div class="grid-3">NOME</div>
              <div class="grid-3">ID</div>
              <div class="grid-6">URL</div>
            </div>
            <div class="menus">
              <div v-for="(menu, i) of menus" :key="'menu' + i" class="line">
                <div class="menu row grid-12" @click="toggleMenu(i)">
                  <div class="grid-3">{{ menu.nome }}</div>
                  <div class="grid-3">{{ menu.id_menu }}</div>
                  <div class="grid-6">{{ menu.url }}</div>
                </div>
                <div v-if="menu.show" class="edit row wrap column-s">
                  <div class="column grid-6 grid-12-s">
                    <label>Nome</label>
                    <input v-model="menu.nome" placeholder="Nome do menu" />
                  </div>
                  <div class="column grid-6 grid-12-s">
                    <label>Id</label>
                    <input v-model="menu.id_menu" placeholder="ID do menu" />
                  </div>
                  <div class="column grid-6 grid-12-s">
                    <label>URL</label>
                    <input v-model="menu.url" placeholder="URL do menu" />
                  </div>
                  <div class="column grid-6 grid-12-s">
                    <label>Criado por</label>
                    <div>{{ menu.nome_criado_por }} em {{ menu.criado_em | date }}</div>
                  </div>
                  <div class="column grid-6 grid-12-s" v-if="menu.nome_alterado_por">
                    <label>Alterado por</label>
                    <div>
                      {{ menu.nome_alterado_por }} em {{ menu.alterado_em | date }}
                    </div>
                  </div>
                  <div class="controls row grid-12 justify-center">
                    <br /><br />
                    <Button @click="editMenu(menu)" :loader="loader.menu.control" layout="green-go"><i
                        class="fa fa-edit" />ATUALIZAR</Button>
                    &nbsp;&nbsp;&nbsp;
                    <Button @click="delMenu(i)" :loader="loader.menu.control" layout="red-go"><i class="fa fa-trash" />
                      APAGAR</Button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="roles grid-6-g">
        <div class="title">
          <i class="fa fa-scroll" />REGRAS
          <Button :layout="showNewRole ? 'red-go' : 'green-go'" title="NOVO MENU" @click="showNewRole = !showNewRole">{{
            showNewRole ? "x" : "+" }}</Button>
        </div>
        <form v-if="showNewRole" class="form" onsubmit="return false" @submit="newRole">
          <div class="title">Nova Regra</div>
          <div class="row justify-space align-center column-s">
            <div class="column grid-3 grid-12-s">
              <label>Nome</label>
              <input class="input" placeholder="Nome" v-model="groupForm.nome" required />
            </div>
            <div class="column grid-4 grid-12-s">
              <label>Descrição</label>
              <input class="input" placeholder="Descrição" v-model="groupForm.descricao" required />
            </div>
            <div class="column grid-3 grid-12-s">
              <label>Perfil</label>
              <select class="input" v-model="groupForm.perfil">
                <option value="">SELECIONE</option>
                <option value="funcionario">Funcionário</option>
                <option value="doutor">Supporter</option>
                <option value="cliente">Cliente</option>
              </select>
            </div>
          </div>
          <div class="controls text-right">
            <Button layout="green-go" type="submit" :loader="loader.group.new">ADICIONAR</Button>
          </div>
        </form>
        <div class="list">
          <div v-if="loader.group.list" class="column align-center justify-center">
            <Loader layout="small" />
          </div>
          <template v-else>
            <div class="head row">
              <div class="grid-3">NOME</div>
              <div class="grid-6">DESCRIÇÃO</div>
              <div class="grid-3">PERFIL</div>
            </div>
            <div class="roles">
              <div v-for="(group, i) of roles" :key="'group' + i" class="line">
                <div class="role row grid-12" @click="toggleRole(i)">
                  <div class="grid-3">{{ group.nome }}</div>
                  <div class="grid-6">{{ group.descricao }}</div>
                  <div class="grid-3">{{ group.perfil }}</div>
                </div>
                <div v-if="group.show" class="edit row wrap column-s">
                  <div class="column grid-4 grid-12-s">
                    <label>Nome</label>
                    <input v-model="group.nome" placeholder="Nome da regra" />
                  </div>
                  <div class="column grid-4 grid-12-s">
                    <label>Descrição</label>
                    <input v-model="group.descricao" placeholder="Descrição da regra" />
                  </div>
                  <div class="column grid-4 grid-12-s">
                    <label>Perfil</label>
                    <select class="input" v-model="group.perfil">
                      <option value="">SELECIONE</option>
                      <option value="funcionario">Funcionário</option>
                      <option value="doutor">Supporter</option>
                      <option value="cliente">Cliente</option>
                    </select>
                  </div>
                  <div class="column grid-6 grid-12-s">
                    <label>Criado por</label>
                    <div>{{ group.nome_criado_por }} em {{ group.criado_em | date }}</div>
                  </div>
                  <div class="column grid-6 grid-12-s" v-if="group.nome_alterado_por">
                    <label>Alterado por</label>
                    <div>
                      {{ group.nome_alterado_por }} em {{ group.alterado_em | date }}
                    </div>
                  </div>
                  <div class="permission grid-12">
                    <div class="title text-center">
                      <label>Permissões</label><br />
                      <div class="select row align-center">
                        <select class="input" v-model="selectMenu">
                          <option value="">Escolha o Menu</option>
                          <option v-for="(m, j) of filterMenu(group)" :key="'mm' + group.id + j" :value="m.id">
                            {{ m.nome }}
                          </option>
                        </select>
                        <Button v-if="selectMenu" @click="addPermission(group.id, i)" :loader="loader.group.permissions"
                          layout="green-go">Adicionar</Button>
                      </div>
                    </div>
                    <div v-if="loader.group.permissions" class="column align-center justify-center">
                      <Loader layout="small" />
                    </div>
                    <div v-else class="row wrap justify-center">
                      <div class="tag pointer" v-for="(permission, j) of group.permissions"
                        :key="'p' + group.id_funcionalidade + j" @click="delPermission(i, j)" title="EXCLUIR PERMISSÃO">
                        {{ permission.nome_funcionalidade }} &nbsp;
                        <Loader v-if="permission.loader" layout="mini" :loader="permission.loader" />
                        <i v-else class="fa fa-trash text-red pointer font-20" />
                      </div>
                    </div>
                  </div>
                  <div class="controls row grid-12 justify-center">
                    <br /><br />
                    <Button @click="delRole(i)" :loader="loader.group.control" layout="red-go"><i class="fa fa-trash" />
                      APAGAR</Button>
                    &nbsp;&nbsp;&nbsp;
                    <Button @click="editRole(group)" :loader="loader.group.control" layout="green-go"><i
                        class="fa fa-edit" /> ATUALIZAR</Button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";

export default {
  name: "Permissions",
  components: { Button, Loader },
  data() {
    return {
      menus: [],
      roles: [],
      loader: {
        menu: {
          new: false,
          list: true,
          control: false,
        },
        group: {
          new: false,
          list: true,
          control: false,
          permissions: true,
        },
      },
      showNewMenu: false,
      showNewRole: false,
      selectMenu: "",
      menuForm: {
        nome: "",
        url: "",
        icone: "Portal Novo",
        id: "",
        metodo: "GET",
        menu: "S",
      },
      groupForm: {
        descricao: "",
        nome: "",
        perfil: "",
      },
    };
  },
  beforeMount() {
    this.get_menus();
    this.get_groups();
  },
  methods: {
    ...mapActions("admin", [
      "MENU_POST",
      "MENU_GET",
      "MENU_DEL",
      "MENU_PUT",
      "GROUP_NEW",
      "GROUP_LIST",
      "GROUP_DEL",
      "GROUP_PUT",
      "GROUP_PERMISSIONS",
      "GROUP_PERMISSIONS_ADD",
      "GROUP_PERMISSIONS_DEL",
    ]),
    addPermission(groupID, index) {
      this.loader.group.permissions = true;
      this.GROUP_PERMISSIONS_ADD({
        id_funcionalidade: this.selectMenu,
        id_grupo: groupID,
      })
        .then(({ status }) => {
          if (status == 201) {
            this.toggleRole(index, true);
            this.selectMenu = "";
          }
          this.loader.group.permissions = false;
        })
        .catch(() => (this.loader.group.permissions = false));
    },
    delPermission(index, jindex) {
      if (confirm("Deseja remover esta permissão?")) {
        let p = this.roles[index].permissions[jindex];
        p.loader = true;
        this.GROUP_PERMISSIONS_DEL(p.id)
          .then(({ status }) => {
            if (status == 200) this.toggleRole(index, true);
            p.loader = false;
          })
          .catch(() => {
            p.loader = false;
          });
      }
    },
    get_menus() {
      this.MENU_GET({})
        .then(({ data }) => {
          this.menus = data;
          this.loader.menu.list = false;
        })
        .catch(() => (this.loader.menu.list = false));
    },
    newMenu() {
      this.loader.menu.new = true;
      /* this.menuForm.id_menu = this.menuForm.nome; */
      this.MENU_POST(this.menuForm)
        .then((r) => {
          if (r.status == 200 || r.status == 201) {
            this.menuForm.nome = "";
            this.menuForm.url = "";
            this.menuForm.id_menu = ""
            this.get_menus();
          }
          this.loader.menu.new = false;
        })
        .catch(() => (this.loader.menu.new = false));
    },
    editMenu(menu) {
      this.loader.menu.control = true;
      this.MENU_PUT(menu)
        .then(() => {
          this.loader.menu.control = false;
          this.get_menus();
        })
        .catch(() => (this.loader.menu.control = false));
    },
    delMenu(index) {
      if (confirm("Deseja apagar este menu?")) {
        this.loader.menu.control = true;
        this.MENU_DEL(this.menus[index].id)
          .then(({ status }) => {
            if (status == 200) this.menus.splice(index, 1);
            this.loader.menu.control = false;
          })
          .catch(() => (this.loader.menu.control = false));
      }
    },
    toggleMenu(index) {
      this.menus[index].show = !this.menus[index].show;
      this.menus = [...this.menus];
    },
    toggleRole(index, show) {
      this.selectMenu = "";
      this.loader.group.permissions = true;
      this.roles[index].show = show || !this.roles[index].show;
      this.roles = [...this.roles];
      if (this.roles[index].show)
        this.GROUP_PERMISSIONS({ id_grupo: this.roles[index].id })
          .then(({ data }) => {
            this.loader.group.permissions = false;
            this.roles[index].permissions = data;
            this.roles = [...this.roles];
          })
          .catch(() => (this.loader.group.permissions = false));
    },

    get_groups() {
      this.GROUP_LIST()
        .then(({ data }) => {
          this.roles = data;
          this.loader.group.list = false;
        })
        .catch(() => (this.loader.group.list = false));
    },
    newRole() {
      this.loader.group.new = true;

      this.GROUP_NEW(this.groupForm)
        .then(({ status }) => {
          if (status == 200 || status == 201) {
            this.groupForm = {
              descricao: "",
              nome: "",
              perfil: "",
              id_menu: ""
            };
            this.get_groups();
          }
          this.loader.group.new = false;
        })
        .catch(() => (this.loader.group.new = false));
    },
    editRole(role) {
      this.loader.group.control = true;
      this.GROUP_PUT(role)
        .then(() => {
          this.loader.group.control = false;
          this.get_groups();
        })
        .catch(() => (this.loader.group.control = false));
    },
    delRole(index) {
      if (confirm("Deseja apagar esta regra?")) {
        this.loader.group.control = true;
        this.GROUP_DEL(this.roles[index].id)
          .then(({ status }) => {
            if (status == 200) this.roles.splice(index, 1);
            this.loader.group.control = false;
          })
          .catch(() => (this.loader.group.control = false));
      }
    },
    filterMenu(group) {
      if (group.permissions) {
        let nm = this.menus;

        group.permissions.map((p) => {
          nm = nm.filter((m) => m.id != p.id_funcionalidade);
        });

        return nm;
      }
    },
  },
  mounted() {
    this.$parent.$children[0].changeMenu("permissions");
  },
};
</script>

<style lang="sass" scoped>
@import "@/assets/scss/vars.scss"
.permissions
  padding: 42px 35px
  @media (max-width: $small)
    padding: 7px

  .title
    font-size: 24px
    font-weight: bold
    color: $gray-4
    text-transform: uppercase

    @media (max-width: $small)
      margin-top: 38px
      margin-bottom: 0px

  .menus, .roles
    margin-top: 21px
    padding: 12px
    .title
      font-size: 19px
      i
        margin-right: 6px
      button
        margin-left: 12px
  .form
    background: white
    border-radius: 21px
    padding: 21px
    padding-top: 9px
    margin-top: 19px
    box-shadow: $shadow
    .title
      text-align: right
      color: $label
      font-size: 16px
      margin-top: 9px
    label
      margin-top: 3zpx
      margin-bottom: 6px
      color: $label
      font-size: 14px
      @media (max-width: $small)
        margin-top: 33px
    input
      @media (max-width: $small)
        width: 90%
    .controls
      margin-top: 33px

  .list
    @include card
    margin-top: 19px
    .head
      color: $purple
      font-weight: bold
      padding: 6px 12px
      height: 33px
      border-bottom: 1px solid #ccc
    .menus, .roles
      max-height: 375px
      overflow-y: auto
      margin: 12px 0
      .line
        padding: 5px
        padding-top: 9px
        border-radius: 4px
        margin-bottom: 12px
        &:hover
          background: $purple
      .menu, .role
        cursor: pointer
        padding: 12px 6px
        height: 27px
        @media (max-width: $small)
          font-size: 14px
      .edit
        margin-top: 12px
        padding: 16px 23px
        background: #eee
        border-radius: 19px
        font-size: 14px
        @include border
        label
          @include label
          @media (max-width: $small)
            margin-top: 12px
        input
          width: 90%
          margin-bottom: 30px
        .permission
          margin-top: 33px
          .title
            margin: 21px 0
            label
              font-size: 17px
            .select
              margin-top: 21px
              padding: 0px 30px
              button
                padding: 15px 12px
                width: 140px
          .tag
            @include card
            margin: 6px
            padding: 12px

        .controls
          padding: 12px
          margin-top: 45px
</style>
